import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { makeEnvironmentProviders } from '@angular/core';
import { AppIdInterceptor } from '../interceptors/app-id.interceptor';
import { UsernameInterceptor } from '../interceptors/username.interceptor';

export const provideShareViewInterceptors = () =>
  makeEnvironmentProviders([
    { provide: HTTP_INTERCEPTORS, multi: true, useClass: AppIdInterceptor },
    { provide: HTTP_INTERCEPTORS, multi: true, useClass: UsernameInterceptor },
  ]);
